module.exports = __webpack_public_path__ + "static/media/styling.dd372648.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Design/img/styling.png
// module id = 283
// module chunks = 0